import { call, put, takeLatest } from 'redux-saga/effects';
import { getDepotRoutine } from '@modules/orders-and-trips/actions';
import { OrdersNTripsApi } from '@modules/orders-and-trips/api';

function* getDepotWorker() {
  const { request, success, failure, fulfill } = getDepotRoutine;
  try {
    yield put(request());
    const {
      data: { data }
    } = yield call(OrdersNTripsApi.getDepot);
    yield put(success({ data }));
  } catch (error) {
    yield put(failure({ error }));
  } finally {
    yield put(fulfill());
  }
}

export function* getDepotWatcher() {
  yield takeLatest(getDepotRoutine.trigger, getDepotWorker);
}
